/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RuleType = {
    _11184809: '11184809',
    VELOCITY: 'VELOCITY',
    INVALID_COUNT: 'INVALID_COUNT',
    MANUAL: 'MANUAL',
    unknown_default_open_api: '11184809'
} as const;
export type RuleType = typeof RuleType[keyof typeof RuleType];


export function instanceOfRuleType(value: any): boolean {
    for (const key in RuleType) {
        if (Object.prototype.hasOwnProperty.call(RuleType, key)) {
            if (RuleType[key as keyof typeof RuleType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RuleTypeFromJSON(json: any): RuleType {
    return RuleTypeFromJSONTyped(json, false);
}

export function RuleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuleType {
    return json as RuleType;
}

export function RuleTypeToJSON(value?: RuleType | null): any {
    return value as any;
}

